export default "__VITE_ASSET__BffcuvMz__"